export enum SentidoViagem {
  IDA = "IDA",
  VOLTA = "VOLTA",
}
